import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "Ebilling";

const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useEbillingState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useAuthState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export function useEbillingDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useEbillingState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export const EbillingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
